<template>
  <div class="app-new-root">
    <el-breadcrumb separator="/" class="title">
      <el-breadcrumb-item
        :to="{ name: 'Apps', query: { project: currentProjectId } }"
        >查看应用</el-breadcrumb-item
      >
      <el-breadcrumb-item>创建新应用</el-breadcrumb-item>
    </el-breadcrumb>

    <TakoPanel class="centent" :header="true">
      <template #header>
        <div class="header">
          <b>创建新应用</b>
        </div>
      </template>
      <el-form
        size="large"
        style="padding-top: 20px"
        label-width="150px"
        :model="form"
        :rules="rules"
        ref="formRef"
      >
        <el-form-item label="应用名称:" prop="appName" class="longInput">
          <el-input
            size="large"
            v-model="form.appName"
            placeholder="给应用起个名字"
          ></el-input>
        </el-form-item>

        <el-form-item label="平台类型:" class="longInput" prop="platform">
          <el-select
            size="large"
            v-model="form.platform"
            style="width: 100%"
            clearable
            placeholder="Android/iOS/Windows/MacOS/Linux"
          >
            <el-option
              v-for="item in types"
              :label="item.label"
              :key="item.platform"
              :value="item.platform"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="应用描述:" class="longInput">
          <el-input
            size="large"
            type="textarea"
            :rows="3"
            placeholder="请输入描述"
            v-model="form.appdesc"
          />
        </el-form-item>
        <el-form-item label="下载短链接:" class="longInput" prop="uri">
          <el-input size="large" v-model="form.uri">
            <template #prepend>{{ takoUrl }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="下载密码设置:" class="longInput" prop="password">
          <el-input
                  style="width:188px"
            size="large"
            v-model="form.password"
            placeholder="不需要密码请留空"
          >
            <template #append>
              <el-tooltip content="生成随机密码">
                <el-button @click="handleGenNewRandomPassword">
                  <i class="iconfont icon-shuffle"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="是否公开:">
            <el-radio v-model="isPublic" :label="true">公开</el-radio>
            <el-radio v-model="isPublic" :label="false">不公开</el-radio>
          </el-form-item> -->
      </el-form>
      <!--底部按钮-->
      <div class="longInput" style="margin-bottom: 15px; text-align: right">
        <router-link
          :to="{ name: 'Apps', query: { project: currentProjectId } }"
        >
          <el-button size="large">返&nbsp;回</el-button>
        </router-link>

        <el-button
          size="large"
          style="width: 160px; margin-left: 20px"
          type="primary"
          @click="handleCreate"
        >
          创&nbsp;建
        </el-button>
      </div>
    </TakoPanel>
  </div>
</template>

<script setup>
import { useProjectStore } from "@/Store/ProjectStore";
import { storeToRefs } from "pinia";
import TakoPanel from "@/Components/TakoPanel.vue";
import { getCurrentInstance, onMounted, ref } from "vue";
import { getDownloadBaseUrl, getRandomPassword } from "@/Utils/UtilTools";
import { ElMessageBox } from "element-plus";
import { apiCreateApp, apiGetUserUploadKey } from "@/Api/AppApi";
import { useRouter } from "vue-router";

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;
const router = useRouter();

const projectStore = useProjectStore();
const { currentProjectId } = storeToRefs(projectStore);

const formRef = ref(null);

const form = ref({
  appName: "",
  platform: "",
  appdesc: "",
  projectid: "",
  uploadkey: "",
  uri: "",
  tags: [],
  password: "",
});
const rules = {
  appName: [{ required: true, message: "请输入应用名称", trigger: "blur" }],
  platform: [{ required: true, message: "请选择平台类型", trigger: "change" }],
  uri: [
    { required: true, message: "请输入下载短链接", trigger: "blur" },
    { min: 4, max: 8, message: "长度在 4 到 8 个字符", trigger: "blur" },
  ],
  password: [{ min: 4, max: 4, message: "长度为4", trigger: "blur" }],
};

const types = [
  { platform: 2, label: "Android" },
  { platform: 1, label: "iOS" },
  { platform: 3, label: "Windows" },
  { platform: 4, label: "MacOS" },
  { platform: 5, label: "Linux" },
];
const takoUrl = getDownloadBaseUrl(router);

onMounted(() => {
  genNewShortUri();
});

function genNewShortUri() {
  form.value.uri = Math.random().toString(36).substring(2).slice(0, 7);
}
function handleGenNewRandomPassword() {
  form.value.password = getRandomPassword();
}

function handleCreate() {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        await ElMessageBox.confirm("您确定创建此应用?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        doCreate();
      } catch (e) {
        // nothing
      }
    } else {
      return false;
    }
  });
}

async function doCreate() {
  let res = await apiGetUserUploadKey(currentProjectId.value);
  if (res.code === 0) {
    form.value.projectid = currentProjectId.value;
    form.value.uploadkey = res.data.uploadkey;

    res = await apiCreateApp(form.value);
    if (res.code === 0) {
      $message.success("创建成功");

      // 刷新列表
      projectStore.getProjectApps();
      router.push({
        name: "Apps",
        query: { project: currentProjectId.value },
      });
    } else {
      $message.error(res.message);
    }
  } else {
    $message.error(res.message);
  }
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  padding-left: 35px;
  padding-top: 15px;
  margin-bottom: 20px;
}

.header {
  background: white;
  font-size: 20px;
  font-weight: bold;
  color: #606266;
}

.centent {
  margin: 20px;
  min-height: 80vh;
}

.longInput {
  width: 560px;
}

.app-new-root /deep/ .el-input-group__prepend{
  width:auto !important;
}
</style>
